// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3SzWt","filesListContainer":"PosDisputesFiles_filesListContainer__1dOT3","filesButton":"PosDisputesFiles_filesButton__17TAN"};